import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  containerModal: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.4)',
    justifyContent: 'center',
  },
  containerFilter: {
    height: 484,
    width: '95%',
    backgroundColor: 'white',
    alignSelf: 'center',
    borderRadius: 16,
    paddingVertical: 15,
  },
  spaceHorizontal: {
    paddingHorizontal: 25,
  },
  iconX: {
    alignSelf: 'flex-end',
  },
  filterText: {
    fontSize: 16,
    fontFamily: 'TCCC-UnityText Bold',
    lineHeight: 19,
    color: 'black',
    marginTop: 20,
  },
  containerDrop: {
    marginTop: 30,
  },
  containerButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 45,
    marginTop: 50,
  },
});
